import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, message, Button, Dropdown, Menu } from "antd";
import TableComponent from "../../components/TableComponent";
import { API_ENDPOINTS } from "../../utils/constants";
import { axiosInstance } from "../../utils/axiosInstance";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
	StatusCell
} from "./styles";
import { AxiosResponse } from "axios";
import { useNewsContext } from "../../context/NewsContext/NewsContext";

interface News {
	newsId: string;
	title: string;
	releaseDate: string;
	displayOrder: number;
	isVisible: boolean;
}
interface NewsListApiResponse {
	result: {
		items: News[];
	};
	error: string | null;
	isSuccessful: boolean;
}

const NewsList = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [pageLoading, setPageLoading] = useState(true);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { clearNewsData } = useNewsContext();


	const navigate = useNavigate();

	const getNewsList = async () => {
		setPageLoading(true);
		try {
			const response: AxiosResponse<NewsListApiResponse> = await axiosInstance.get(
				API_ENDPOINTS.GET_NEWS_LIST
			);

			setTableData(response?.data?.result?.items);
		} catch (error) {
			return [[], false];
		} finally {
			setPageLoading(false);
		}
	};

	const handleDelete = async (newsId: string) => {
		try {
			await axiosInstance.post(API_ENDPOINTS.REMOVE_NEWS, { newsId });
			message.success("Haber başarıyla silindi.");
			getNewsList();
		} catch (error) {
			message.error("Haber silinirken bir hata oluştu.");
		} finally {
			setIsModalVisible(false);
		}
	};

	useEffect(() => {
		getNewsList();
		clearNewsData();
	}, []);


	const columns = useMemo(() => [
		createColumn({
			title: "Sıra",
			dataIndex: "displayOrder",
			width: 30,
			sorterType: "numeric",
		}),
		createColumn({
			title: "Başlık",
			dataIndex: "title",
			width: 300,
			sorterType: "string",
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "releaseDate",
			width: 50,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "Durum",
			dataIndex: "isVisibleStatus",
			width: 50,
			sorterType: "string",
			render: (text, record) => (
				<StatusCell $isVisible={!record.isVisible}>{!record.isVisible ? "Pasif" : "Aktif"}</StatusCell>
			),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menu = (
					<Menu>
						<Menu.Item key="edit" onClick={() => navigate(`/edit-news/${record.newsId}`)}>
							Güncelle
						</Menu.Item>
						<Menu.Item key="delete" onClick={() => {
							setCurrentItem(record);
							setIsModalVisible(true);
						}}>
							Sil
						</Menu.Item>
					</Menu>
				);

				return (
					<Dropdown overlay={menu} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [tableData]);


	return (
		<div>
			<HeaderComponent>Haberler</HeaderComponent>
			<Container>
				<Spin spinning={pageLoading}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate(`/add-news`)}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!pageLoading && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>

			<Modal
				title="Haberi Sil"
				visible={isModalVisible}
				onOk={() => handleDelete(currentItem.newsId)}
				onCancel={() => setIsModalVisible(false)}
				okText="Evet"
				cancelText="Hayır"
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						key="submit"
						type="primary"
						danger
						onClick={() => handleDelete(currentItem.newsId)}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.title}"`}</strong> haberini silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default NewsList;
